/* eslint-disable no-undef */
// sets dynamic public path for lazy-loaded or code-split webpack assets https://webpack.js.org/guides/public-path/#on-the-fly
__webpack_public_path__ = window.__INITIAL_STATE__.publicPath;
